/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitPersonalInfoResponseDto
 */
export interface SubmitPersonalInfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SubmitPersonalInfoResponseDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitPersonalInfoResponseDto
     */
    message?: string;
}

/**
 * Check if a given object implements the SubmitPersonalInfoResponseDto interface.
 */
export function instanceOfSubmitPersonalInfoResponseDto(value: object): value is SubmitPersonalInfoResponseDto {
    return true;
}

export function SubmitPersonalInfoResponseDtoFromJSON(json: any): SubmitPersonalInfoResponseDto {
    return SubmitPersonalInfoResponseDtoFromJSONTyped(json, false);
}

export function SubmitPersonalInfoResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPersonalInfoResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

  export function SubmitPersonalInfoResponseDtoToJSON(json: any): SubmitPersonalInfoResponseDto {
      return SubmitPersonalInfoResponseDtoToJSONTyped(json, false);
  }

  export function SubmitPersonalInfoResponseDtoToJSONTyped(value?: SubmitPersonalInfoResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'message': value['message'],
    };
}

